import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpResponse,
  HttpEventType,
} from "@angular/common/http";
import { Observable, combineLatest } from "rxjs";
import { IAppState } from "../../../store/states/app";
import { Store, select } from "@ngrx/store";
import {
  selectAuthenticatedUser,
  selectIsAuthenticated,
  authenticationErrors,
} from "src/app/store/selectors";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  /**
   *
   */
  private authenticated: boolean = false;

  /**
   *
   */
  private user: any;

  /**
   *
   * @param _store
   */
  constructor(private _store: Store<IAppState>) {
    combineLatest(
      this._store.select(selectIsAuthenticated),
      this._store.select(selectAuthenticatedUser),
    ).subscribe((data: any) => {
      const [authenticated, user] = data;
      this.authenticated = authenticated;
      this.user = user;
    });
  }

  /**
   *
   * @param request
   * @param next
   */
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (this.authenticated) {
      request = request.clone({
        setHeaders: {
          Authorization: `${this.user.data.token_type} ${this.user.data.access_token}`,
        },
      });
    }
    return next.handle(request);
  }
}
